import { lazy, ComponentType } from 'react';

/**
 * A wrapper around React.lazy that handles "Failed to fetch dynamically imported module" errors
 * which occur when a new version of the app is deployed and old chunk files are removed.
 */
export const lazyRetry = (componentImport: () => Promise<{ default: ComponentType<any> }>) => {
    return lazy(async () => {
        const pageHasAlreadyBeenForceRefreshed = JSON.parse(
            window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false'
        );

        try {
            const component = await componentImport();
            window.sessionStorage.setItem('page-has-been-force-refreshed', 'false');
            return component;
        } catch (error) {
            if (!pageHasAlreadyBeenForceRefreshed) {
                // The error could be a "Failed to fetch" error for a chunk that no longer exists
                // We force a refresh to get the latest version of the app
                window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');
                return window.location.reload() as any;
            }

            // If we've already refreshed and it still fails, throw the error
            throw error;
        }
    });
};
